import LanguageRoundedIcon from '@mui/icons-material/LanguageRounded';
import Box from '@mui/material/Box';
import is from '@sindresorhus/is';
import type { FunctionComponent, ReactNode } from 'react';
import { Fragment, useContext } from 'react';

import { ApplicationContext } from '~/shared/context/context';
import type { Ambition } from '~/shared/data-contract/ambition';

import { ContentHeadline, ContentWrapper } from '../../../../../design/components/containers/ContentWrapper';
import { useScrollToLocationHash } from '../../../../use-scroll-to-location-hash';
import { CardPlaceholder } from '../common/CardPlaceholder';
import { AmbitionList } from './AmbitionList';

type AmbitionContentProps = {
    readonly action?: ReactNode | undefined;
    readonly ambitions: readonly Ambition[] | undefined;
};

export const AmbitionContent: FunctionComponent<AmbitionContentProps> = ({ action, ambitions }) => {
    const { translate } = useContext(ApplicationContext);

    useScrollToLocationHash();

    return (
        <ContentWrapper>
            <Box
                id="ambitions"
                role="table"
                sx={{
                    position: 'relative',
                    top: -75,
                }}
            />
            <ContentHeadline actions={action} text={translate('pages.recruiter-profile.ambitions.title')} />
            {/** biome-ignore lint/complexity/noUselessFragments: suppressed due to migration */}
            <Fragment>
                {is.array(ambitions) && is.nonEmptyArray(ambitions) ? (
                    <AmbitionList ambitions={ambitions} />
                ) : (
                    <CardPlaceholder
                        placeholderIcon={<LanguageRoundedIcon />}
                        placeholderText={translate('pages.recruiter-profile.ambitions.placeholder')}
                    />
                )}
            </Fragment>
        </ContentWrapper>
    );
};
